export default "__VITE_ASSET__BRy4nUWt__"